import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";

const MoreNewsCart = ({ item }) => {
  const { title, image, date_stamp, _id, youtube_embed, short_text } = item;

  const dates = new Date(date_stamp); // convert it to a Date object
  const options = { year: "numeric", month: "long", day: "numeric" };
  const dateInBengali = dates.toLocaleDateString("bn-IN", options); // convert the date to Bengali
  const [timeDifference, setTimeDifference] = useState("");

  useEffect(() => {
    const backendDate = new Date(date_stamp);

    const banglaDigits = ["০", "১", "২", "৩", "৪", "৫", "৬", "৭", "৮", "৯"];

    const convertToBanglaDigits = (number) => {
      return number
        .toString()
        .split("")
        .map((digit) => banglaDigits[parseInt(digit)])
        .join("");
    };
    const calculateTimeDifference = () => {
      const now = new Date();
      const diffInMilliseconds = now - backendDate;

      const diffInSeconds = Math.floor(diffInMilliseconds / 1000);
      const diffInMinutes = Math.floor(diffInSeconds / 60);
      const diffInHours = Math.floor(diffInMinutes / 60);
      const diffInDays = Math.floor(diffInHours / 24);

      if (diffInDays < 10) {
        if (diffInDays > 0) {
          return `${convertToBanglaDigits(diffInDays)} দিন আগে`;
        } else if (diffInHours > 0) {
          return `${convertToBanglaDigits(diffInHours)} ঘন্টা আগে`;
        } else if (diffInMinutes > 0) {
          return `${convertToBanglaDigits(diffInMinutes)} মিনিট আগে`;
        } else {
          return `${convertToBanglaDigits(diffInSeconds)} সেকেন্ড আগে`;
        }
      } else {
        return `${dateInBengali}`;
      }
    };

    setTimeDifference(calculateTimeDifference());

    const intervalId = setInterval(() => {
      setTimeDifference(calculateTimeDifference());
    }, 60000); // Update every minute

    return () => clearInterval(intervalId);
  }, [dateInBengali, date_stamp]);

  var date = new Date(parseInt(_id));
  const moreButtonYear = date.getFullYear();

  const limitShortText = (text, limit = 491) => {
    if (!text) return "";

    return text.length > limit ? text.slice(0, limit) + "....." : text;
  };

  return (
    <div>
      <div className="">
        <Link to={`/newsDetails/${_id}`} className="flex gap-4 border-b-[1px] border-[#ccc] pb-4">
          <figure className="relative overflow-hidden">
            <img
              src={`https://www.iskconbangla.com/img/${moreButtonYear}_news_sm/${image}`}
              alt="news"
              className="w-full h-20 object-cover transition-transform duration-500 group-hover:scale-105"
            />
            {youtube_embed && (
              <img
                src={image}
                alt="YouTube"
                className="w-8 h-8 absolute bottom-2 right-2"
              />
            )}
          </figure>

          <div className="p-3">
            {/* Title */}
            <p className="text-black font-medium line-clamp-2 text-[17px] NewsFontTitle">
              {title}
            </p>

            {/* Time */}
            <p className="text-gray-400 text-sm pt-1 text-[12px] font-thin NewsFontTitle">{timeDifference}</p>

            {/* Short Text */}
          </div>
        </Link>
      </div>
    </div>
  );
};

export default MoreNewsCart;
